import { render, staticRenderFns } from "./MyPurchase.vue?vue&type=template&id=c2114bc6&scoped=true&"
import script from "./MyPurchase.vue?vue&type=script&lang=js&"
export * from "./MyPurchase.vue?vue&type=script&lang=js&"
import style0 from "./MyPurchase.vue?vue&type=style&index=0&id=c2114bc6&lang=less&scoped=true&"
import style1 from "./MyPurchase.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2114bc6",
  null
  
)

export default component.exports